import { formatRoundDate } from '~/utils/round';

const typeLabels = {
  round_analysis: 'Omgång',
  news_article: 'Nyhet',
  tv: 'TV',
  chronicle: 'Krönika',
};

export function formatTeaserType(type) {
  if (!typeLabels.hasOwnProperty(type)) {
    console.warn('formatTeaserType, unknown type', type);
    return '';
  }

  return typeLabels[type];
}

export function getMetaLabels(round) {
  if (!round) {
    return [];
  }

  return [
    round.bet_type_label || round.bet_type,
    round.meets.map(meet => meet.track_name).join('/'),
    formatRoundDate(round.round_date),
  ];
}

export function getBetTypeColor(article, round = null) {
  if (!article.round) {
    return;
  }

  if (article.round.slug === round?.slug) {
    return;
  }

  return `betTypes.${article.round.bet_type.toLowerCase()}.primary`;
}

export function buildArticleLink(article) {
  if (article.type === 'round_analysis') {
    return {
      type: 'ROUND_TIP',
      payload: {
        bet_type: article.round.bet_type.toLowerCase(),
        slug: article.round.slug,
      },
    };
  }

  if (article.round) {
    const roundArticleTypes = {
      news_article: 'ROUND_NEWS',
      chronicle: 'ROUND_CHRONICLE',
      tv: 'ROUND_TV',
    };

    return {
      type: roundArticleTypes[article.type],
      payload: {
        slug: article.slug,
        bet_type: article.round?.bet_type.toLowerCase(),
        round_slug: article.round?.slug,
      },
    };
  }

  const articleTypes = {
    news_article: 'NEWS',
    chronicle: 'CHRONICLE',
    tv: 'TV',
  };
  return {
    type: articleTypes[article.type],
    payload: {
      slug: article.slug,
    },
  };
}
